import {dateFormats} from '../constants/date';
import formatDate from 'date-fns/format';
// TODO: something wrong on test
// import Bugsnag from '../../bugsnag';

export const datePipe = (date?: string, format = dateFormats.fullDate) => {
  if (!date) {
    return '';
  }
  try {
    return formatDate(new Date(date), format);
  } catch (e) {
    // Bugsnag.addMetadata('datePipe error payload', {date});
    // Bugsnag.notify(e);
    return date;
  }
};
